var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgButtonS(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 117,
    height: 55,
    viewBox: "0 0 117 55",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M110.175 5.6635H112.74V7.78139H116V46.8855H112.74V51.1258H110.175V54.0502H39.1556H6.7854V51.1258H3.99964V46.8855H1V7.78139H3.99964V5.6635H6.7854V0.833008H110.175V5.6635Z",
    fill: "current",
    stroke: "current"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgButtonS);
export default __webpack_public_path__ + "static/media/ButtonS.0f30511d17c3c779e516ba662b6ed2ca.svg";
export { ForwardRef as ReactComponent };